import { useQuery } from '@tanstack/react-query';
import { cardStatusApi } from '../services/api';

export const useCardStatusHistory = (consumerCode, tenantCode, cardProxy) => {
  return useQuery({
    queryKey: ['cardStatusHistory', consumerCode, tenantCode, cardProxy],
    queryFn: async () => {
      const response = await cardStatusApi.getHistory(consumerCode, tenantCode, cardProxy);
      return response.data;
    },
    enabled: !!consumerCode && consumerCode.trim().length > 0,
    staleTime: 2 * 60 * 1000,
  });
};
